import { AdditionalVisualDescription } from 'Components/Worksheets/Core/Fields';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { SieveAdditionFieldSet } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components/SieveAdditionFieldSet';
import { getById, ISieveSize, SieveSizeId } from 'Data/ViewModels/Equipment/ISieveSize';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field, RadioGroup, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection } from '../../../../../Layout';
import { ManageSeparationsButton } from '../../../Components';
import { getNumberOfSeparations, getSeparationSieveSizeIds } from '../../../Helpers';

let TestPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const anySeparations = useSelector(pipe(createWorksheetSelector!('', false), getNumberOfSeparations, (n) => n > 0));
  const separatingSievesList = useSelector(
    combine(
      [
        pipe(createWorksheetSelector!('', false), getSeparationSieveSizeIds),
        createWorksheetSelector!('Equipment.AllSieveSizes'),
      ],
      (ids: SieveSizeId[], allSieves: ISieveSize[]) =>
        ids.length > 0 ? ids.map((id: SieveSizeId) => getById(allSieves, id)?.Caption ?? 'Not set').join(', ') : 'None'
    )
  );
  const allowVisualDescriptionEntry = useSelector(
    createWorksheetSelector!('Preparation.AllowAdditionalVisualDescriptionEntry')
  );

  const cumulativeOptions = [
    { label: 'Cumulative', value: true },
    { label: 'Individual', value: false },
  ];

  return (
    <PageSection heading="Test Preparation">
      <NamePrefixModifier appendNamePrefix="Preparation">
        <ListFieldSection>
          <AdditionalVisualDescription editable visible={allowVisualDescriptionEntry} />
          <Field input={<RadioGroup />} name="TestStandardAndMethod" />
          <Field
            input={<RadioGroup />}
            name="AreSieveMassesCumulative"
            label="Sieve Retained Masses Are"
            options={cumulativeOptions}
          />
          <Field
            input={<RadioGroup />}
            name="ArePanMassesCumulative"
            label="Pan Masses Are"
            options={cumulativeOptions}
          />
          <SieveAdditionFieldSet />
          <FieldSet>
            <div>
              <ManageSeparationsButton maxSeparations={2} defaultSieveSizes={['20_0', '6_3']} />
            </div>
            <Field
              input={<Checkbox />}
              name="InitialSeparationPerformed"
              visible={anySeparations}
              confirm={true}
              confirmText="Changing the type of separation may clear existing data. Are you sure you want to continue?"
            />
          </FieldSet>
          <Field input={<TextOutput />} label="Separating Sieve(s)" value={separatingSievesList} />
        </ListFieldSection>
      </NamePrefixModifier>
    </PageSection>
  );
};

TestPreparationPageSection = withInjectedProps(TestPreparationPageSection);

export { TestPreparationPageSection };
export default TestPreparationPageSection;
